const FLOW_SCALE = 100;

function toNumber(value) {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : 0;
}

export function scaleFlowAmount(value) {
  return toNumber(value) / FLOW_SCALE;
}

export function formatFlowAmount(value, options = {}) {
  const amount = scaleFlowAmount(value);
  const digits = Number.isInteger(options.digits) ? options.digits : 2;

  return amount.toLocaleString('zh-CN', {
    minimumFractionDigits: digits,
    maximumFractionDigits: digits
  });
}

export function formatFlowCurrency(value, options = {}) {
  const currency = options.currency || 'CNY';

  return new Intl.NumberFormat('zh-CN', {
    style: 'currency',
    currency,
    minimumFractionDigits: Number.isInteger(options.digits) ? options.digits : 2,
    maximumFractionDigits: Number.isInteger(options.digits) ? options.digits : 2
  }).format(scaleFlowAmount(value));
}

// User management recharge details intentionally show the stored order amount.
// Those values are already the business unit used by the admin recharge records.
export function formatRawFlowCurrency(value, options = {}) {
  const currency = options.currency || 'CNY';

  return new Intl.NumberFormat('zh-CN', {
    style: 'currency',
    currency,
    minimumFractionDigits: Number.isInteger(options.digits) ? options.digits : 2,
    maximumFractionDigits: Number.isInteger(options.digits) ? options.digits : 2
  }).format(toNumber(value));
}
